import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../app/shared/environment.service';

/**
 * HTTP Interceptor: Intercepts the http calls done by ngrx/data to append the x-delivery-guid header for auth. through IF-Proxy
 */
@Injectable({
  providedIn: 'root',
})
export class CumulusAuthInterceptorService implements HttpInterceptor {
  private readonly environmentService = inject(EnvironmentService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/zprs/json_stateless/user')) {
      return next.handle(req);
    }
    const deliveryGuid = this.environmentService.getDeliveryGuid();
    if (deliveryGuid) {
      req = req.clone({
        headers: req.headers.set('x-delivery-guid', deliveryGuid),
      });
    }
    return next.handle(req);
  }
}
